import {defineStore} from 'pinia'

import {type NewsCategoriesInterface, type NewsInterface} from "~~/server/types/NewsInterface";

export const useNewsStore = defineStore('news', {
    state: () => ({
        _categories: [] as NewsCategoriesInterface[],
        _list: [] as NewsInterface[],

        _promise_categories: null as Promise<void> | null,
        _promise_list: null as Promise<void | NewsInterface[]> | null,

        _loaded_categories: false,
        _loaded_list: false,
        _hydrated_list: false,
        _loading_list: false,
    }),
    getters: {
        list: s => s._list,
        categories: s => s._categories,
        categories_tree: (state) => {
            if (state._categories===null || state._categories.length === 0) return [];

            const categoryMap = new Map<number, NewsCategoriesInterface>();
            const validParents = new Set<number>();

            // Създаваме map с всички категории и събираме валидните parent_id
            state._categories.forEach(category => {
                categoryMap.set(category.id, { ...category, children: [] });
                if (category.parent_id) validParents.add(category.parent_id);
            });

            const tree: NewsCategoriesInterface[] = [];

            state._categories.forEach(category => {
                const currentCategory = categoryMap.get(category.id);
                if (!currentCategory) return;

                // Ако parent_id го няма в validParents и не е 0, игнорирай категорията
                if (category.parent_id && category.parent_id !== 0 && !categoryMap.has(category.parent_id)) {
                    return;
                }

                if (category.parent_id && categoryMap.has(category.parent_id)) {
                    categoryMap.get(category.parent_id)!.children!.push(currentCategory);
                } else {
                    tree.push(currentCategory);
                }
            });

            return tree;
        },
        loaded_list: (s) => s._hydrated_list && s._list.length > 0,

    },
    actions: {
      async loadNews(firstLimit = 200, nextLimit = 5000) {
        if (this._loaded_list) return
        if (this._promise_list) return this._promise_list

        const { $api } = useNuxtApp()

        this._loading_list = true

        this._promise_list = (async () => {
          this._list = []

          const first =
            (await $api<NewsInterface[]>('blog', {
              method: 'GET',
              query: { limit: firstLimit, page: 1 },
            })) ?? []

          this._list.push(...first)
          this._hydrated_list=true;

          if (first.length < firstLimit) {
            this._loaded_list = true
            return
          }

          let page = 2
          while (true) {
            const arr =
              (await $api<NewsInterface[]>('blog', {
                method: 'GET',
                query: { limit: nextLimit, page },
              })) ?? []

            if (!arr.length) break
            this._list.push(...arr)
            if (arr.length < nextLimit) break
            page++
          }

          this._loaded_list = true
        })()

        try {
          await this._promise_list
        } finally {
          this._promise_list = null
          this._loading_list = false
        }
      },

        resetProducts() {
        this._list = []
        this._hydrated_list = false
        this._loaded_list = false
        this._loading_list = false
        this._promise_list = null
      },
        async loadCategories() {
            if (this._loaded_categories) return
            if (this._promise_categories) return this._promise_categories;
            const { $api } = useNuxtApp()

            this._promise_categories = (async () => {
                const res = await $api<NewsCategoriesInterface[]>('blog/categories', { method: 'GET' })
                this._categories = res ?? []
                this._loaded_categories = true
            })()

            try {
                await this._promise_categories
            }
            finally {
                this._promise_categories = null
            }
        },
        findProductsByCategory(url: string, limit?: number, page?: number) {
                if (!this._categories?.length || !this._list?.length) return [];
                const category = this._categories.find(c => c.url === url);
                if (!category) return [];
                const categoryIds = new Set<number>();
                const collectChildren = (parentId: number) => {
                    categoryIds.add(parentId);
                    this._categories
                        .filter(c => c.parent_id === parentId)
                        .forEach(child => {
                            collectChildren(child.id);
                        });
                };

                collectChildren(category.id);
                const productsInCategories = this._list.filter(p =>
                    categoryIds.has(p.category_id)
                );
                if (!limit || limit <= 0) {
                    return productsInCategories;
                }
                const currentPage = page && page > 0 ? page : 1;
                const start = (currentPage - 1) * limit;
                const end = start + limit;

                return productsInCategories.slice(start, end);
            },
        async loadSingleNews(slug:string):Promise<NewsInterface> {
            const { $api } = useNuxtApp()
            const res= await $api<NewsInterface>(`blog/${slug}`, { method: 'GET' })
            const index = this._list.findIndex(p => p.id === res.id);
            if (index === -1) {
                //this._list.push(res);
            } else {
                this._list[index] = res;
            }
            return res;
        },

    }

})

